import React from 'react';
import mdPhoto from '../../assets/MD.webp';
import frPhoto from '../../assets/FR.webp';
import './styles.css';

function About() {
  const founders = [
    {
      id: 'fr',
      name: 'Fairoz Basha',
      role: 'Founder',
      heading: 'Founder & Visionary Behind FR Fisheries Since 1988',
      subheading: 'The Vision That Started FR Fisheries',
      photo: frPhoto,
      alt: 'Portrait of Fairoz Basha, Founder of FR Fisheries',
      body: [
        'In 1988, I began my journey with a small fish stall in Bangalore with a simple vision — to provide people with fresh, high-quality seafood at fair and honest prices.',
        'Through dedication, hard work, and strong relationships with fishing communities, that small venture gradually grew into a trusted wholesale seafood supplier.',
        'From the beginning, our focus has always been freshness, reliability, and trust. These values helped FR Fisheries grow into a respected name among restaurants, retailers, and seafood distributors.',
        'Today, seeing the next generation expand the business while preserving these principles fills me with pride. Our commitment to quality and honesty continues to guide everything we do.',
      ],
    },
    {
      id: 'md',
      name: 'Mohammed Faizan',
      role: 'MD',
      heading: 'Leading the Next Generation of FR Fisheries',
      subheading: 'Expanding the Future of FR Fisheries',
      photo: mdPhoto,
      alt: 'Portrait of Mohammed Faizan, Managing Director of FR Fisheries',
      body: [
        'It is a privilege to carry forward the legacy of FR Fisheries founded by my father in 1988. His dedication and commitment to quality built a strong foundation that continues to inspire our growth.',
        'As Managing Director, my focus is on strengthening our supply network, improving logistics, and expanding our reach across India while maintaining the same commitment to freshness and trust.',
        'We continuously work to build stronger partnerships with restaurants, retailers, and distributors while ensuring our seafood meets the highest quality standards.',
        'Our vision is to transform FR Fisheries into a nationwide seafood distribution leader while continuing the legacy of excellence and trust established over the past three decades.',
      ],
    },
  ];

  return (
    <section className="about" id="about">
      <div className="about-hero">
        <h1>Our Story</h1>
        <p>
          From a humble seafood stall in 1988 to a trusted wholesale seafood supplier today — FR
          Fisheries is built on tradition, trust, and freshness.
        </p>
      </div>

      {founders.map((f, index) => (
        <div key={f.id} className={`founder ${index % 2 !== 0 ? 'reverse' : ''}`}>
          <div className="founder-image">
            <img src={f.photo} alt={f.alt} loading="lazy" decoding="async" />

            <div className="image-dark-overlay"></div>

            <div className="giant-text">{f.role}</div>

            <div className="founder-overlay">
              <h3>{f.name}</h3>
            </div>
          </div>

          <div className="founder-content">
            <h2 className="founder-heading">{f.heading}</h2>

            <p className="sub">{f.subheading}</p>

            {f.body.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </div>
        </div>
      ))}
      <div className="about-quote">
        “Fresh seafood, honest relationships, and a legacy built on trust.”
      </div>
    </section>
  );
}

export default About;
